module.exports = __webpack_public_path__ + "static/media/undefined_user.171008fb.jpg";